<template>
  <div class="safedig-contact-us">
    <h1 class="safedig-page-title">{{ $t('contactUs.title') }}</h1>
    <p class="safedig-page-intro">
      {{ $t('contactUs.intro') }}
    </p>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.toContactIurc') }}</h2>
      <p>
        {{ $t('contactUs.email') }} <a href="mailto:SafeDigIndiana@urc.in.gov">SafeDigIndiana@urc.in.gov</a>
      </p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.importantLegalInfo') }}</h2>
      <p>
        {{ $t('footer.copyright', { year }) }}
        {{ $t('footer.allRightsReserved') }}
      </p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.overview') }}</h2>
      <p>
        {{ $t('contactUs.overviewText') }}
      </p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.copyrightInfo') }}</h2>
      <p>
        {{ $t('contactUs.copyrightText') }}
      </p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.trademarkTitle') }}</h2>
      <p>{{ $t('contactUs.trademarkText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.useOfInfoTitle') }}</h2>
      <p>{{ $t('contactUs.useOfInfoText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.complianceTitle') }}</h2>
      <p>{{ $t('contactUs.complianceText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.disclaimerTitle') }}</h2>
      <p>{{ $t('contactUs.disclaimerText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.limitationTitle') }}</h2>
      <p>{{ $t('contactUs.limitationText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.jurisdictionTitle') }}</h2>
      <p>{{ $t('contactUs.jurisdictionText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.revisionsTitle') }}</h2>
      <p>{{ $t('contactUs.revisionsText') }}</p>
    </section>

    <section class="safedig-content-section">
      <h2 class="safedig-page-title">{{ $t('contactUs.consentsTitle') }}</h2>
      <p>
        {{ $t('contactUs.consentsTextBefore') }}
        <a href="mailto:URCGeneralCounsel@urc.IN.gov">URCGeneralCounsel@urc.IN.gov</a>
        {{ $t('contactUs.consentsTextAfter') }}
      </p>
      <p class="safedig-address-block">{{ $t('contactUs.consentsAddress') }}</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SafeDigContactUs',
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.safedig-contact-us {
  max-width: 800px;
}

.safedig-page-title {
  font-size: 34px;
  font-weight: 700;
  color: #3d4852;
  margin: 26px 0 13px;
  line-height: 1.3;
}

.safedig-page-intro {
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.safedig-content-section {
  margin-bottom: 2rem;
}



.safedig-content-section p {
  font-size: 0.95rem;
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
}

.safedig-content-section a {
  color: #3e7799;
  text-decoration: none;
}

.safedig-content-section a:hover {
  text-decoration: underline;
}

.safedig-address-block {
  white-space: pre-line;
  margin-top: 0.5rem;
}
</style>
